import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'
import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import GenerateReportModal from '@modals/GenerateReportModal'

import PageContent from './components/PageContent'

const defaultState = {
  showGenerateReportModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

export type PageContextPayload = {
  callbacks: {
    showGenerateReportModal: (payload: object) => void,
  },
}

const callbacks = (component: string, setState: SetState) => {
  const componentCallbacks = {
    GenerateReportModal: {
      closeModal: () => setState({ showGenerateReportModal: false }),
      generateTeamPerformanceReport: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const Overview = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showGenerateReportModal,
  } = state

  const modalContext = useModals()
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showGenerateReportModal: () => {
        setState({ showGenerateReportModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <GenerateReportModal
          callbacks={callbacks('GenerateReportModal', setState)}
          showModal={showGenerateReportModal}
        />

      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Overview
